import { takeEvery } from 'redux-saga/effects';
import { authActionCreators } from '..';
import { removeAuthLocalStorageValue } from '../authLocalStorageService';

function* resetItOverrides(action: ReturnType<typeof authActionCreators.resetItOverides>) {
  removeAuthLocalStorageValue('auth/itOverridePermissions');
  removeAuthLocalStorageValue('auth/itOverrideUser');
}

export function* watchrResetItOverides() {
  yield takeEvery(authActionCreators.resetItOverides.match, resetItOverrides);
}
